import { render, staticRenderFns } from "./before-page-header.vue?vue&type=template&id=a30133a2&scoped=true&"
import script from "./before-page-header.vue?vue&type=script&lang=js&"
export * from "./before-page-header.vue?vue&type=script&lang=js&"
import style0 from "./before-page-header.vue?vue&type=style&index=0&id=a30133a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30133a2",
  null
  
)

export default component.exports